//@flow
import React, { Component } from "react";
import "./list.scss";
import ListContent from "../list-content";
import type { ProductType } from "../types/product.js";
import type { PricingType } from "../types/pricing.js";
import type { ProductPurchasability } from "../types/publicpurchasable.js";
import ListInfo from "../list-info";
import { Loading } from "../loading";

type Props = {
  products: Array<ProductType>,
  pricesMap: Map<number, PricingType>,
  productPurchasabilityMap: Map<number, ProductPurchasability>,
  postCodeAvailable: boolean,
  onRemove: (productCode: number) => void,
  onQuantityChanged: (productCode: number, newQuantity: number) => void,
  onShowPostcodeClicked: () => void,
  isLoading: boolean,
  isLoadingPurchasability: boolean,
  isLoggedInUser: boolean
};

class List extends Component<Props> {
  render() {
    const { onRemove, onQuantityChanged, onShowPostcodeClicked } = this.props;

    return (
      <div className="wishlist-main__list">
        {this.props.products.length > 0 && (
          <ListInfo
            products={this.props.products}
            isPostCodeAvailable={this.props.postCodeAvailable}
            productPurchasabilityMap={this.props.productPurchasabilityMap}
            isLoadingPurchasability={this.props.isLoadingPurchasability}
          />
        )}
        {this.props.isLoading && <Loading />}
        {!this.props.isLoading && this.props.products.length === 0 && (
          <div className="wishlist-main__list-no-product">
            <p>
              You have <strong>no products</strong> added to your list.
            </p>
            <p>
              Use this feature to collate a list of your favourite products or
              to compare possible options. To build your list, simply click the
              'Add to List' button on any product.
            </p>
          </div>
        )}
        {this.props.products.length > 0 && (
          <ListContent
            products={this.props.products}
            pricesMap={this.props.pricesMap}
            productPurchasabilityMap={this.props.productPurchasabilityMap}
            isPostCodeAvailable={this.props.postCodeAvailable}
            onRemove={onRemove}
            onShowPostcodeClicked={onShowPostcodeClicked}
            onQuantityChanged={onQuantityChanged}
            isLoadingPurchasability={this.props.isLoadingPurchasability}
            isLoggedInUser={this.props.isLoggedInUser}
          />
        )}
        {this.props.products.length > 0 && (
          <ListInfo
            products={this.props.products}
            isPostCodeAvailable={this.props.postCodeAvailable}
            productPurchasabilityMap={this.props.productPurchasabilityMap}
            isLoadingPurchasability={this.props.isLoadingPurchasability}
          />
        )}
      </div>
    );
  }
}

export default List;
